// extracted by mini-css-extract-plugin
export var cardLayout = "_8m-1";
export var paginationContainer = "_8m-0";